/**
 * Cart-level embroidery MOQ warning (UX layer only).
 *
 * Embroidery requires a minimum of 4 embroidered items per order. This is
 * enforced server-side by the moq-validation Shopify Function at checkout
 * (the source of truth) — this script only gives early feedback in the cart
 * drawer/page and blocks the visible checkout button. It does NOT stop a
 * direct /checkout URL, Shop Pay, or any path that bypasses these forms.
 */
(function () {
  var MOQ = 4;
  var isBlocked = false;

  function warningEls() {
    return Array.prototype.slice.call(document.querySelectorAll("[data-embroidery-moq-warning]"));
  }

  function embroideredQuantity(cart) {
    return (cart.items || []).reduce(function (total, item) {
      var properties = item.properties || {};
      if (properties["_embroidery_moq"] === "true") {
        return total + item.quantity;
      }
      return total;
    }, 0);
  }

  function renderWarning(count) {
    var strings = (window.theme && window.theme.strings) || {};
    var template = strings.embroideryMoqWarning || "Embroidery requires a minimum of 4 embroidered items — you currently have [count].";
    return template.replace("[count]", count);
  }

  function refresh() {
    if (!window.theme || !window.theme.cart || typeof window.theme.cart.getCart !== "function") {
      return;
    }
    window.theme.cart.getCart().then(function (cart) {
      var count = embroideredQuantity(cart);
      var shouldBlock = count > 0 && count < MOQ;
      isBlocked = shouldBlock;

      warningEls().forEach(function (el) {
        if (shouldBlock) {
          el.textContent = renderWarning(count);
          el.hidden = false;
        } else {
          el.hidden = true;
          el.textContent = "";
        }
      });
    });
  }

  function onCartFormSubmit(evt) {
    if (!isBlocked) return;
    evt.preventDefault();
    var warning = evt.currentTarget.querySelector("[data-embroidery-moq-warning]");
    if (warning) {
      warning.hidden = false;
      warning.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    refresh();
    ["CartDrawerForm", "CartPageForm"].forEach(function (id) {
      var form = document.getElementById(id);
      if (form) form.addEventListener("submit", onCartFormSubmit);
    });
  });

  document.addEventListener("ajaxProduct:added", refresh);
  document.addEventListener("cart:updated", refresh);
})();
